import { Pipe, PipeTransform } from "@angular/core";
import { Observable } from 'rxjs/Observable';
import { StoreService } from "../../providers/store.service";

@Pipe({
  name: "storeById"
})
export class StorePipe implements PipeTransform {
  constructor(private storeService: StoreService) { }

  transform(storeId: string = null, clientId: string, eventId: string): Observable<any> {
    if (storeId) {
      return this.storeService.getItem(clientId, storeId, eventId);
    } else {
      return Observable.empty();
    }
  }
}



// WEBPACK FOOTER //
// ./src/pipes/store/store.ts